module.exports = __webpack_public_path__ + "static/media/arrowLeftBlack.020e8a21.svg";